export default __webpack_public_path__ + "static/united-kingdom-7be3d5a2c15bcfba1b7c7c7d99a9721a.png";